import { useContextState } from "../../../../../../../../hooks/theme"


const useStyles = () => {
    const { colors } = useContextState()
    return {
        container: (isEven: boolean, isParent: boolean, secondLevel: boolean) => ({
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            padding: isParent ? '0px 0px 0px 0px' : secondLevel ? 3 : '24px 0px 24px 24px',
            bgcolor: isParent
                ? 'transparent'
                : isEven
                    ? 'rgba(25,118,210,0.05)'
                    : 'white',
            minHeight: isParent ? '50vh' : '0',
        }),
        title: {
            color: colors.backgroundDark,
            fontSize: '16px',
            paddingBottom: 2,
            fontWeight: 'bold'
        },
        notContainer: {
            mt: 2
        }
    }
}

export { useStyles }
